import { gql } from '@/__generated__';

const GET_DGA_CONFIGURATION_WITH_SUBMISSIONS = gql(`#graphql
  query GetDGAConfigurationWithSubmissions($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      dga {
        id
        configuration {
          id
          code
          rut
          password
          type
          frequency
          hour
          weekday
          day
          enabled
        }
      }
    }
  }
`);

export default GET_DGA_CONFIGURATION_WITH_SUBMISSIONS;
